// Mock data for Sand-tec AS landing page

export const services = [
  {
    id: 1,
    title: "EU-kontroll last og buss over 7.500 KG",
    price: "3338,-",
    category: "tungbil"
  },
  {
    id: 2,
    title: "EU-kontroll tilhenger 1-3 aksler",
    price: "2610,-",
    category: "tilhenger"
  },
  {
    id: 3,
    title: "EU-kontroll tilhenger 4/5/6/7 aksler",
    price: "2955,-",
    category: "tilhenger"
  },
  {
    id: 4,
    title: "2-årskontroll fartsskriver",
    price: "2770,-",
    category: "tungbil"
  },
  {
    id: 5,
    title: "EU-etterkontroll TUNGBIL/HENGER",
    price: "825,-",
    description: "Gratis når reparasjonene er utført her",
    category: "tungbil"
  },
  {
    id: 6,
    title: "Timepris tungbil",
    price: "Fra 1015,-",
    description: "Dynamisk minkende pris. Enkeltstående arbeidstime kr. 1500,-. Store volum ned til kr. 1015,- (Store volum er gjenstand for kontrakt)",
    category: "tungbil"
  },
  {
    id: 7,
    title: "EU-kontroll person/varebil u/3500 kg",
    price: "960,-",
    category: "personbil"
  },
  {
    id: 8,
    title: "Dekkhotell lastebil, 1 hjul pr. halvår",
    price: "397,-",
    description: "Inkluderer lasting-lossing, omlegg og hjulskift",
    category: "tungbil"
  },
  {
    id: 9,
    title: "Klima Service TUNGBIL",
    price: "3038,-",
    description: "Inkluderer påfylling av kjølemedie",
    category: "tungbil"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Teknisk leder",
    role: "Sertifisert Mekaniker",
    image: "https://images.unsplash.com/photo-1624471621620-c30f427546ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxjb21tZXJjaWFsJTIwdHJ1Y2slMjBtZWNoYW5pY3xlbnwwfHx8fDE3NjMzMzQ1OTd8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Service Tekniker",
    role: "EU-kontroll Spesialist",
    image: "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxhdXRvJTIwd29ya3Nob3B8ZW58MHx8fHwxNzYzMzM0NjAzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "Verksted Sjef",
    role: "Tungbil Ekspert",
    image: "https://images.pexels.com/photos/4315574/pexels-photo-4315574.jpeg"
  }
];

export const reviews = [
  {
    id: 1,
    author: "Ole Hansen",
    rating: 5,
    text: "Rask og profesjonell service! Fikk time samme dag og jobben ble gjort perfekt.",
    date: "2 uker siden"
  },
  {
    id: 2,
    author: "Maria Larsen",
    rating: 5,
    text: "Svært fornøyd med EU-kontrollen. Grundig gjennomgang og god kommunikasjon.",
    date: "1 måned siden"
  },
  {
    id: 3,
    author: "John Andersen",
    rating: 5,
    text: "Beste verkstedet for tungbil i området. Anbefales på det sterkeste!",
    date: "3 uker siden"
  }
];

export const contactInfo = {
  phone: "+47 62 97 40 50",
  email: "post@sand-tec.no",
  address: "Industrivegen 4, 2120 Sagstua",
  hours: {
    weekdays: "07:00 - 16:00",
    saturday: "Stengt",
    sunday: "Stengt"
  }
};

// Mock booking slots (6 parallel slots)
export const getAvailableSlots = (date) => {
  const slots = [];
  const startHour = 7;
  const endHour = 16;
  
  for (let hour = startHour; hour < endHour; hour++) {
    for (let slot = 1; slot <= 6; slot++) {
      slots.push({
        id: `${date}-${hour}-${slot}`,
        time: `${hour.toString().padStart(2, '0')}:00`,
        slot: slot,
        available: Math.random() > 0.3 // 70% chance of being available
      });
    }
  }
  
  return slots;
};

export const mockBooking = async (bookingData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        bookingId: `BK-${Date.now()}`,
        ...bookingData
      });
    }, 1000);
  });
};